export default __webpack_public_path__ + "static/media/DtVhJx26TKEr37c9YHZ5knwJxArepzhN.19dc878f.woff2";